export const USER_ID_STORAGE_KEY = 'user-id'
export const BCKS_SESSION_STORAGE_KEY = 'bcks-session'
export const PHICOS_SESSION_STORAGE_KEY = 'phicos-session'
export const BCKS_UI_STATE_STORAGE_KEY = 'bcks-ui-state'
